import { Routes } from '@angular/router';
import { authRoutes } from './modules/auth/auth.routes';
import { apiKeysRoutes } from './modules/api-keys/api-keys.routes';
import { agentsRoutes } from './modules/agents/agents.routes';
import { reportsRoutes } from './modules/reports/reports.routes';
import { logAnalysisRoutes } from './modules/log-analysis/log-analysis.routes';
import { issuesRoutes } from './modules/issues/issues.routes';
import { inboxRoutes } from './modules/inbox/inbox.routes';
import { usersRoutes } from './modules/users/users.routes';
import { edgeDevicesRoutes } from './modules/edge-devices/edge-devices.routes';
import { wildcardCertificatesRoutes } from './modules/wildcard-certificates/wildcard-certificates.routes';
import { trafficMetricsRoutes } from './modules/traffic-metrics/traffic-metrics.routes';
import { dnsRecordsRoutes } from './modules/dns-records/dns-records.routes';
import { llmSettingsRoutes } from './modules/llm-settings/llm-settings.routes';
import { remediationsRoutes } from './modules/remediations/remediations.routes';
import { AuthGuard } from './core/guards/auth.guard';
import { AdminGuard } from './core/guards/admin.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./core/components/root-redirect.component').then(
        (m) => m.RootRedirectComponent
      ),
  },
  {
    path: 'auth',
    children: authRoutes,
  },
  {
    path: 'edge-helpers/shared/:token',
    loadComponent: () =>
      import('./modules/edge-helpers/edge-helpers-public.component').then(
        (m) => m.EdgeHelpersPublicComponent
      ),
  },
  {
    path: '',
    loadComponent: () =>
      import('./core/layout/main-layout/main-layout.component').then(
        (m) => m.MainLayoutComponent
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        data: { title: 'Dashboard', breadcrumb: 'Dashboard' },
        loadComponent: () =>
          import('./modules/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent
          ),
      },
      {
        path: 'api-keys',
        data: { title: 'API Keys', breadcrumb: 'API Keys' },
        children: apiKeysRoutes,
      },
      {
        path: 'agents',
        data: { title: 'Agents', breadcrumb: 'Agents' },
        children: agentsRoutes,
      },
      {
        path: 'reports',
        data: { title: 'Reports', breadcrumb: 'Reports' },
        children: reportsRoutes,
      },
      {
        path: 'log-analysis',
        data: { title: 'Log Analysis', breadcrumb: 'Log Analysis' },
        children: logAnalysisRoutes,
      },
      {
        path: 'issues',
        data: { title: 'Issues', breadcrumb: 'Issues' },
        children: issuesRoutes,
      },
      {
        path: 'inbox',
        data: { title: 'Inbox', breadcrumb: 'Inbox' },
        children: inboxRoutes,
      },
      {
        path: 'tunnels',
        data: { title: 'Tunnels', breadcrumb: 'Tunnels' },
        loadComponent: () =>
          import('./modules/tunnels/tunnels.component').then(
            (m) => m.TunnelsComponent
          ),
      },
      {
        path: 'profile',
        data: { title: 'Profile', breadcrumb: 'Profile' },
        loadComponent: () =>
          import('./modules/profile/profile.component').then(
            (m) => m.ProfileComponent
          ),
      },
      {
        path: 'users',
        data: { title: 'Users', breadcrumb: 'Users' },
        children: usersRoutes,
        canActivate: [AdminGuard],
      },
      {
        path: 'wildcard-certificates',
        data: {
          title: 'Wildcard Certificates',
          breadcrumb: 'Wildcard Certificates',
        },
        children: wildcardCertificatesRoutes,
        canActivate: [AdminGuard],
      },
      {
        path: 'dns-records',
        data: {
          title: 'DNS Records',
          breadcrumb: 'DNS Records',
        },
        children: dnsRecordsRoutes,
        canActivate: [AdminGuard],
      },
      {
        path: 'traffic-monitoring',
        data: {
          title: 'Traffic Monitoring',
          breadcrumb: 'Traffic Monitoring',
        },
        children: trafficMetricsRoutes,
        canActivate: [AdminGuard],
      },
      {
        path: 'llm-settings',
        data: {
          title: 'LLM Settings',
          breadcrumb: 'LLM Settings',
        },
        children: llmSettingsRoutes,
        canActivate: [AdminGuard],
      },
      {
        path: 'edge-devices',
        data: { title: 'Edge Devices', breadcrumb: 'Edge Devices' },
        children: edgeDevicesRoutes,
      },
      {
        path: 'remediations',
        data: { title: 'Remediations', breadcrumb: 'Remediations' },
        children: remediationsRoutes,
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
    ],
  },
  {
    path: '**',
    data: { title: 'Page not found' },
    loadComponent: () =>
      import('./core/components/not-found.component').then(
        (m) => m.NotFoundComponent,
      ),
  },
];
